<template>
  <v-flex>
    <v-card class="client-notes">
      <v-flex class="title-container">
        <v-card-title class="card-title">
          Notes
          <span v-if="!notes" @click="addFocus">ENTER NOTE</span>
          <span v-else @click="addFocus">EDIT NOTE</span>
        </v-card-title>
      </v-flex>
      <v-divider />
      <v-card-text v-if="profile" class="notes-container">
        <v-icon
          v-if="showIcon && notes"
          v-model="showIcon"
          size="18"
          class="edit-icon"
          @click="addFocus"
        >
          fas fa-pen
        </v-icon>
        <textarea
          ref="textarea"
          v-model="notes"
          class="notes-body"
          @keyup.enter="saveNote"
          @blur="saveNote"
          @focus="showIcon = false"
        />
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { updateNote } from '../../../services/profile'

export default {
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      notes: '',
      showIcon: true
    }
  },
  computed: {
    ...mapState('agent', ['agentData'])
  },
  watch: {
    profile() {
      this.mapNotes()
    }
  },
  created() {
    this.mapNotes()
  },
  methods: {
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA'
    }),
    ...mapMutations('agent', {
      setAgentData: 'SET_AGENT_DATA'
    }),
    async saveNote() {
      this.$refs.textarea.blur()
      this.showIcon = true
      const updatedNotes = await updateNote(
        this.agentData,
        this.profile,
        this.notes
      )
      const agentProfile = { ...this.agentData }
      const note = this.agentData.notes.find(
        item => item.refUserId === updatedNotes.refUserId
      )
      if (note) {
        note.message = updatedNotes.message
      } else agentProfile.notes.push(updatedNotes)
      this.setAgentData(agentProfile)
    },
    addFocus() {
      this.$refs.textarea.focus()
    },
    mapNotes() {
      if (this.agentData && this.agentData.notes) {
        const noteBody = this.agentData.notes.find(
          item => item.refUserId === this.profile._id
        )
        this.notes = noteBody ? noteBody.message : ''
      }
    }
  }
}
</script>

<style lang="sass">
.client-notes
  min-height: 350px
  display: flex
  flex-flow: column
  flex-grow: 1
  align-items: stretch
  height: 100%
.client-notes .v-card__text
  padding: 0 !important
.notes-container
  border: 1px solid $color-grey
  width: 93% !important
  margin: 16px auto
  height: 80%
.notes-body
  padding: 15px 35px 15px 15px !important
  overflow: scroll
  resize: none
  width: 100%
  height: 100%
  display: flex
  flex: 1
.edit-icon
  color: $hwayzBrandGold !important
  position: absolute
  top: 8rem
  right: 4rem
</style>
